<template>
  <div class="container">
    <div class="row d-flex justify-content-center">
      <div
        v-for="group in mappedGroups"
        :key="group.id"
        class="col-8 col-md-6 col-lg-3 mx-auto"
      >
        <GroupCard
          v-bind="group"
          class="my-auto"
          :animated="myGroupId == group.id"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import GroupCard from "@/components/activity/GroupCardPreview.vue";

// Data
export default {
  name: "GroupsPreview",
  components: { GroupCard },
  computed: {
    ...mapGetters("groups", ["getMappedGroups"]),
    mappedGroups() {
      let groups = [...this.getMappedGroups];
      return groups;
    }
  },
  props: {
    myGroupId: {
      type: String,
      default: null
    }
  }
};
</script>
